export default __webpack_public_path__ + "static/media/ic_previous.95c86c27.svg";